// import crypto from 'crypto';
// import Unixfs from 'ipfs-unixfs'; // @0.1.16
// import { DAGNode } from 'ipld-dag-pb'; // @0.18.1
// import bs58 from 'bs58'; // @4.0.1
import md5 from 'md5';

export const getHash = async (data: Buffer): Promise<string> => {
  // const words = new Uint32Array(data);
  // let hex = '';
  // for (let i = 0; i < words.length; i++) {
  //   hex += words.get(i).toString(16); // this will convert it to a 4byte hex string
  // }
  // console.log(hex);
  // const unixFs = new Unixfs('file', data);
  // const dagNode = new DAGNode(unixFs.marshal());
  // const link = await dagNode.toDAGLink();
  // const multihash = bs58.encode(link.Hash.multihash).toString();
  const hash = md5(data);
  return hash;
};
